import { VideoAttributesModel } from '../../../interface/inspirations-and-planning';
import AnimatedDiv from '../../atoms/animated-div/animated-div';

export function VideoCard(props: VideoAttributesModel) {
  const { Title, Youtube_link } = props;

  return (
    <AnimatedDiv className="p-4 border border-primaryGray">
      <p className="uppercase text-caption font-MuseoSans300 font-bold text-left">
        {Title}
      </p>
      <iframe
        allowFullScreen
        className="w-full h-80 py-4 lg:p-4"
        src={Youtube_link}
      />
    </AnimatedDiv>
  );
}

export default VideoCard;
